import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import athenaLogoBlue from '../assets/athena-logo-blue.png';
import '../styles/NotFound.css';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className='not-found-container'>
      <div className='not-found-content'>
        <Paper elevation={3} className='not-found-paper'>
          <Box
            display='flex'
            flexDirection='column'
            alignItems='center'
            gap={3}
            py={4}
            px={3}
          >
            <img
              src={athenaLogoBlue}
              alt='Athena Logo'
              className='not-found-logo'
            />

            <Box className='not-found-icon-container'>
              <SearchOffIcon className='not-found-icon' />
            </Box>

            <Typography variant='h1' className='not-found-error-code'>
              404
            </Typography>

            <Typography variant='h4' component='h1' className='not-found-title'>
              Page Not Found
            </Typography>

            <Typography
              variant='body1'
              color='text.secondary'
              textAlign='center'
              maxWidth={450}
            >
              The page you're looking for doesn't exist or has been moved.
              Please check the URL or navigate back to the homepage.
            </Typography>

            <Box display='flex' gap={2} mt={2} flexWrap='wrap' justifyContent='center'>
              <Button
                variant='contained'
                size='large'
                onClick={handleGoHome}
                className='not-found-btn-primary'
              >
                Go to Homepage
              </Button>
              <Button
                variant='outlined'
                size='large'
                onClick={() => navigate(-1)}
                className='not-found-btn-secondary'
              >
                Go Back
              </Button>
            </Box>

            <Box className='not-found-help-box'>
              <Typography variant='body2' color='text.secondary' textAlign='center'>
                Need help? Contact:{' '}
                <a
                  href='mailto:athena@npsfoundation.org'
                  className='not-found-link'
                >
                  athena@npsfoundation.org
                </a>
              </Typography>
            </Box>
          </Box>
        </Paper>
      </div>
    </div>
  );
};

export default NotFound;
